import { gql } from "@apollo/client";

const ORGANIZATION_ALBUMS = gql`
  query organizationQuery(
    $id: ID!
    $take: Int
    $cursor: ID
    $filters: OrganizationMediaFilters
  ) {
    organization(id: $id) {
      id
      albumsCount
      mediaSets(take: $take, cursor: $cursor, filters: $filters) {
        id
        name
        preview {
          id
          filename
        }
        source {
          id
          fixture {
            id
            scheduledStart
            roles(where: { type: { name: "PARTICIPANT" } }) {
              id
              organization {
                id
                name
              }
              profile {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;

export default ORGANIZATION_ALBUMS;
